"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _solarReact = require("@solar/solar-react");

var _CertificateCard = _interopRequireWildcard(require("../Certificate/CertificateCard"));

var _FabricateList = _interopRequireDefault(require("./FabricateList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    sheet: {
      margin: 12,
      marginLeft: 24,
      marginRight: 24,
      padding: 12
    },
    preTypography: {
      whiteSpace: 'pre-line'
    }
  };
});

var FabricateInfo = function FabricateInfo(_ref) {
  var _fabricate$images, _fabricate$documents, _fabricate$technicalS, _certificate$technica, _fabricate$restricted, _certificate$restrict, _productionUnit$manuf, _product$cover, _mappedCertificate$pr, _certificate$publicFa, _certificate$publicFa2, _certificate$publicFa3;

  var certificate = _ref.certificate,
      fabricate = _ref.fabricate,
      user = _ref.user,
      isFavourite = _ref.isFavourite,
      isEditable = _ref.isEditable,
      isFavourable = _ref.isFavourable,
      openCertificate = _ref.openCertificate,
      onClickFavorite = _ref.onClickFavorite,
      onClickNavButton = _ref.onClickNavButton,
      openFabricate = _ref.openFabricate,
      editFabricate = _ref.editFabricate,
      setPdfOpen = _ref.setPdfOpen,
      setImageOpen = _ref.setImageOpen,
      checkACL = _ref.checkACL,
      canView = _ref.canView,
      checkDownload = _ref.checkDownload,
      labels = _ref.labels;
  var classes = useStyles();
  var key = certificate.key,
      renderKey = certificate.renderKey,
      name = certificate.name,
      code = certificate.code,
      description = certificate.description,
      specification = certificate.specification,
      coverSrc = certificate.coverSrc,
      _certificate$images = certificate.images,
      images = _certificate$images === void 0 ? [] : _certificate$images,
      _certificate$document = certificate.documents,
      documents = _certificate$document === void 0 ? [] : _certificate$document,
      pdf = certificate.pdf,
      product = certificate.product,
      productionUnit = certificate.productionUnit;
  var allImages = [].concat(_toConsumableArray(images), _toConsumableArray((_fabricate$images = fabricate === null || fabricate === void 0 ? void 0 : fabricate.images) !== null && _fabricate$images !== void 0 ? _fabricate$images : []));
  var allDocuments = [].concat(_toConsumableArray(documents), _toConsumableArray((_fabricate$documents = fabricate === null || fabricate === void 0 ? void 0 : fabricate.documents) !== null && _fabricate$documents !== void 0 ? _fabricate$documents : [])); // const { name, code, description, specification, coverSrc, images = [] } = fabricate;
  // const { acl } = certificate;

  var technicalSheet = (fabricate === null || fabricate === void 0 ? void 0 : (_fabricate$technicalS = fabricate.technicalSheet) === null || _fabricate$technicalS === void 0 ? void 0 : _fabricate$technicalS.published) || (certificate === null || certificate === void 0 ? void 0 : (_certificate$technica = certificate.technicalSheet) === null || _certificate$technica === void 0 ? void 0 : _certificate$technica.published);
  var restrictedTechnicalSheet = (fabricate === null || fabricate === void 0 ? void 0 : (_fabricate$restricted = fabricate.restrictedTechnicalSheet) === null || _fabricate$restricted === void 0 ? void 0 : _fabricate$restricted.published) || (certificate === null || certificate === void 0 ? void 0 : (_certificate$restrict = certificate.restrictedTechnicalSheet) === null || _certificate$restrict === void 0 ? void 0 : _certificate$restrict.published);
  var mappedCertificate = (0, _CertificateCard.certificateMapper)(certificate, null, null, labels);
  return /*#__PURE__*/_react["default"].createElement(_solarReact.CoverView, {
    onClickNav: onClickNavButton,
    title: /*#__PURE__*/_react["default"].createElement(_core.Box, {
      display: "flex",
      flexDirection: "column"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "heading",
      color: "inherit",
      noWrap: true
    }, productionUnit === null || productionUnit === void 0 ? void 0 : (_productionUnit$manuf = productionUnit.manufacturer) === null || _productionUnit$manuf === void 0 ? void 0 : _productionUnit$manuf.name, "\xA0"), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "title",
      color: "inherit",
      noWrap: true
    }, renderKey)), fabricate && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "heading",
      color: "inherit",
      noWrap: true
    }, fabricate.code, " - ", fabricate.name)),
    cover: product === null || product === void 0 ? void 0 : (_product$cover = product.cover) === null || _product$cover === void 0 ? void 0 : _product$cover.src,
    action: /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, null, isEditable ? /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      color: "inherit",
      onClick: function onClick() {
        editFabricate(fabricate === null || fabricate === void 0 ? void 0 : fabricate._id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], null)) : '', isFavourable ? /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      color: "inherit",
      onClick: function onClick() {
        onClickFavorite();
      }
    }, !user || !isFavourite ? /*#__PURE__*/_react["default"].createElement(_FavoriteBorder["default"], null) : /*#__PURE__*/_react["default"].createElement(_Favorite["default"], null)) : '')
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.description), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    classes: {
      root: (0, _classnames["default"])(classes.sheet, classes.preTypography)
    },
    style: {
      padding: 0
    }
  }, description), fabricate && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    classes: {
      root: (0, _classnames["default"])(classes.sheet, classes.preTypography)
    },
    style: {
      padding: 0
    }
  }, fabricate.description), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.certificate), certificate && /*#__PURE__*/_react["default"].createElement(_CertificateCard["default"], _extends({
    noMedia: false
  }, mappedCertificate, {
    onClickPDF: function onClickPDF() {
      return setPdfOpen(pdf.src);
    }
  })), fabricate && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.specification), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    classes: {
      root: (0, _classnames["default"])(classes.sheet, classes.preTypography)
    },
    style: {
      padding: 0
    }
  }, fabricate.specification)), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.benor), /*#__PURE__*/_react["default"].createElement(_core.List, null, technicalSheet && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    interactive: true,
    onClickOpen: function onClickOpen() {
      setPdfOpen(fabricate ? fabricate.technicalSheetRef : technicalSheet.src);
    },
    onClickDownloadFile: function onClickDownloadFile() {
      checkDownload({
        certificate: certificate,
        doc: technicalSheet,
        unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id
      }, function () {
        window.open(technicalSheet.src, '__blank');
      });
    },
    label: "".concat(technicalSheet.fileName, " - ").concat(technicalSheet.version),
    description: fabricate && fabricate.technicalSheetRef.start.page > -1 ? labels.pages({
      start: fabricate.technicalSheetRef.start.page + 1,
      end: fabricate.technicalSheetRef.end.page + 1
    }) : technicalSheet.formattedDate,
    fileUrl: technicalSheet.src
  }), restrictedTechnicalSheet && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    interactive: true,
    onClickOpen: function onClickOpen() {
      checkACL({
        unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
        certificate: certificate,
        prop: 'restrictedTechnicalSheet'
      }, function () {
        return setPdfOpen(fabricate ? fabricate.restrictedTechnicalSheetRef : restrictedTechnicalSheet.src);
      });
    },
    onClickDownloadFile: function onClickDownloadFile() {
      checkACL({
        unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
        certificate: certificate,
        prop: 'restrictedTechnicalSheet'
      }, function () {
        checkDownload({
          certificate: certificate,
          doc: restrictedTechnicalSheet,
          unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id
        }, function () {
          window.open(restrictedTechnicalSheet.src, '__blank');
        });
      });
    },
    label: "".concat(restrictedTechnicalSheet.fileName, " - ").concat(restrictedTechnicalSheet.version),
    description: fabricate && fabricate.restrictedTechnicalSheetRef.start.page > -1 ? labels.pages({
      start: fabricate.restrictedTechnicalSheetRef.start.page + 1,
      end: fabricate.restrictedTechnicalSheetRef.end.page + 1
    }) : technicalSheet.formattedDate,
    fileUrl: restrictedTechnicalSheet.src
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.docs), /*#__PURE__*/_react["default"].createElement(_core.List, null, pdf && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    interactive: true,
    label: labels.certificate,
    description: mappedCertificate === null || mappedCertificate === void 0 ? void 0 : (_mappedCertificate$pr = mappedCertificate.profileProps) === null || _mappedCertificate$pr === void 0 ? void 0 : _mappedCertificate$pr.validityLabel,
    fileUrl: pdf.src,
    onClickOpen: function onClickOpen() {
      return setPdfOpen(pdf.src);
    },
    onClickDownloadFile: function onClickDownloadFile() {
      window.open(pdf.src, '__blank');
    }
  }), allDocuments.map(function (_ref2) {
    var _id = _ref2._id,
        src = _ref2.src,
        caption = _ref2.caption,
        formattedDate = _ref2.formattedDate,
        acl = _ref2.acl;
    return canView({
      certificate: certificate,
      prop: 'documents',
      acl: acl,
      unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id
    }) && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      key: _id,
      interactive: true,
      label: caption,
      description: formattedDate,
      fileUrl: src,
      isImage: false,
      onClickOpen: function onClickOpen() {
        checkACL({
          unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
          certificate: certificate,
          prop: 'documents',
          acl: acl
        }, function () {
          return setPdfOpen(src);
        });
      },
      onClickDownloadFile: function onClickDownloadFile() {
        checkACL({
          unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
          certificate: certificate,
          prop: 'documents',
          acl: acl
        }, function () {
          checkDownload({
            certificate: certificate,
            doc: {
              _id: _id
            },
            unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id
          }, function () {
            return window.open(src, '__blank');
          });
        });
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.images), /*#__PURE__*/_react["default"].createElement(_core.List, null, coverSrc && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    interactive: true,
    label: labels.cover,
    fileUrl: coverSrc,
    isImage: true
  }), allImages.map(function (_ref3) {
    var _id = _ref3._id,
        acl = _ref3.acl,
        src = _ref3.src,
        caption = _ref3.caption,
        formattedDate = _ref3.formattedDate;
    return canView({
      certificate: certificate,
      prop: 'images',
      acl: acl,
      unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id
    }) && /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      key: _id,
      interactive: true,
      label: caption,
      fileUrl: src,
      description: formattedDate,
      isImage: true,
      onClickOpen: function onClickOpen() {
        checkACL({
          unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
          certificate: certificate,
          prop: 'images',
          acl: acl
        }, function () {
          return setImageOpen(src);
        });
      },
      onClickDownloadFile: function onClickDownloadFile() {
        checkACL({
          unitId: productionUnit === null || productionUnit === void 0 ? void 0 : productionUnit._id,
          certificate: certificate,
          prop: 'images',
          acl: acl
        }, function () {
          window.open(src, '__blank');
        });
      }
    });
  })), ((_certificate$publicFa = certificate === null || certificate === void 0 ? void 0 : (_certificate$publicFa2 = certificate.publicFabricates) === null || _certificate$publicFa2 === void 0 ? void 0 : _certificate$publicFa2.length) !== null && _certificate$publicFa !== void 0 ? _certificate$publicFa : 0) > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.allFabricates), /*#__PURE__*/_react["default"].createElement(_FabricateList["default"], {
    fabricates: (_certificate$publicFa3 = certificate === null || certificate === void 0 ? void 0 : certificate.publicFabricates) !== null && _certificate$publicFa3 !== void 0 ? _certificate$publicFa3 : [],
    openFabricate: openFabricate
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    height: "10vh"
  }));
};

FabricateInfo.propTypes = {
  certificate: _propTypes["default"].object.isRequired,
  editFabricate: _propTypes["default"].func.isRequired,
  fabricate: _propTypes["default"].object,
  isFavourite: _propTypes["default"].bool.isRequired,
  openFabricate: _propTypes["default"].func.isRequired
};
FabricateInfo.defaulProps = {
  isFavourite: false
};
var _default = FabricateInfo;
exports["default"] = _default;